<template>
<main class="signup-form">
    <div class="container">
        <div class="row justify-content-center m-0">
            <div class="col-md-4 pt-4">

                <google-login></google-login>

                <div class="card mt-4 mb-2">
                <div class="card-header normal text-center">Start your free trial</div>
                    <div class="card-body">

                        <div class="alert alert-secondary text-center" role="alert" v-if="error_message">
                        <span v-html="error_message"></span>
                        </div>
                        
                        <div class="alert alert-success mb-0 text-center" role="alert" v-if="success_message">
                            <span v-html="success_message"></span>
                        </div>
                          
                          <div v-if="!submitted">
                            <div class="form-group mb-3">
                                <input type="text" placeholder="Name" class="form-control2" v-model="name">
                            </div>

                            <div class="form-group mb-3">
                                <input type="text" placeholder="Surname" class="form-control2" v-model="surname">

                            </div>

                            <div class="form-group mb-3">
                                <input type="text" placeholder="Email" class="form-control2" v-model="email">
                            </div>

                            <div class="d-grid mx-auto">
                                <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin fa-1x"></i></div>
                                <button v-else type="submit" :class="'btn btn-danger btn-block'" @click="submitForm">Register</button>
                            </div>
                          </div>

                    </div>

                </div>

                <div v-if="!submitted" class="text-center pt-2 pb-3"><a href="/login">Login</a></div>

            </div>
        </div>
    </div>
</main>
</template>

<script>

export default {
  data() {
    return {
      name: '',
      surname: '',
      email: '',
      error_message: '',
      success_message: '',
      loading: false,
      submitted: false,
    };
  },

  methods: {

      submitForm() {

          this.error_message = '';

          if (this.name=='') { this.sweetfire('Please enter your name')}
          else if (this.surname=='') { this.sweetfire('Please enter your surname')}
          else if (this.email=='') { this.sweetfire('Please enter your email address')}
          else if (this.account=='') { this.sweetfire('Account not selected')}

          else {

          this.loading = true;

          axios
          .post('/register-post', {
            name: this.name, 
            surname: this.surname, 
            email: this.email})
          .then((response) => {
            
            if (response.data.success) {
                this.success_message = response.data.message;
                this.submitted = true;
            }

            else {
              this.error_message = response.data.message;
              this.loading = false;
            }

          });

          }
      
      },


    sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },

  },
};
</script> 